
// Copyright 2002-2013, University of Colorado Boulder

/**
 * Returns version identifier for the simulation.
 * TODO: generate this file at build time, reading package.json
 */
define( 'version',[],function() {
  'use strict';
  return function() { return '1.0.0-rc16'; };
} );